<template>
  <div v-if="!isEditInstructions && projectInstructions != ''" class="project-instructions">
    <b>{{ $t('projectPage.projectInstructions') }}:</b>
    <markdown-span :content="projectInstructions"></markdown-span>
  </div>
  <div v-else-if="isEditInstructions">
    <div class="textarea-div">
      <textarea class="textarea" aria-multiline="true"
                aria-labelledby="projectInstructions" aria-required="true" contenteditable="true"
                :placeholder="$t('projectPage.enterInstructions')"
                v-model="projectInstructionsModel">
      </textarea>
      <div class="textarea-charcount-container">
        <span class="is-pulled-left help is-danger">
          {{ projectInstructionsErrorMessage }}
        </span>
        <span class="is-pulled-right is-size-7 help" :class="{
              'is-danger': isProjectInstructionsValidationError,
              'has-text-grey-light': !isProjectInstructionsValidationError
              }">
          {{ characterLimit - projectInstructionsModel.length }} {{ $t("projectPage.chars") }} {{ $t("projectPage.remaining") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownSpan from '@/components/Controls/MarkdownSpan'
import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import mixin from '../tabs'

export default {
  components: {
    MarkdownSpan
  },
  mixins: [componentState, mixin, auth],
  props: {
    characterLimit: {
      type: Number,
      default: 2500
    }
  },
  data: function () {
    return {
      isEditInstructions: false,
      projectInstructionsErrorMessage: '',
      projectInstructionsModel: '',
      isProjectInstructionsValidationError: false,
      isLoading: false
    }
  },
  watch: {
    projectInstructionsModel: function () {
      if (this.projectInstructionsModel.length > this.characterLimit) {
        this.isProjectInstructionsValidationError = true
        this.projectInstructionsErrorMessage = this.$t('projectPage.instructionsTooLongError')
        this.$emit('onSetDisableSaveButton', true)
      } else {
        this.isProjectInstructionsValidationError = false
        this.projectInstructionsErrorMessage = ''
        this.$emit('onSetDisableSaveButton', false)
      }
    },
    // Signal the parent when this component accepts the toggling between reading and editing.
    isEditInstructions: function () {
      this.$emit('onSetEditInstructions', this.isEditInstructions)
    },
    // While loading, signal the parent to disable its save button.
    isLoading: function () {
      this.$emit('onSetDisableSaveButton', this.isLoading)
    }
  },
  computed: {
    projectInstructions: function () {
      return this.project.instructionSection || ''
    }
  },
  methods: {
    toggleEditInstructions: function () {
      if (this.isProjectInstructionsValidationError) {
        return
      }
      // Ensures that excess whitespace (that might have unintentionally been
      // typed by the user) is discarded.
      this.projectInstructionsModel = this.projectInstructionsModel.trim()

      if (!this.isEditInstructions) {
        this.isEditInstructions = true
        this.projectInstructionsModel = this.projectInstructions
      } else if (this.projectInstructionsModel === this.projectInstructions) {
        this.isEditInstructions = false
      } else {
        // The project instructions have changed. Let's save the modification.
        const id = this.project.id
        const data = {
          instructionSection: this.projectInstructionsModel
        }
        this.isLoading = true

        this.$store.dispatch('projectUpdateInstructions', { id, data })
          .then(() => {
            this.isEditInstructions = false
            this.isLoading = false
            this.projectInstructionsErrorMessage = ''
          })
          .catch(err => {
            console.error(err)
            this.isLoading = false
            this.projectInstructionsErrorMessage = this.$t('projectPage.updateInstructionsError')
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.textarea {
  resize: none;
  color: $grey;
  font-size: 0.8rem;
}

.textarea-div {
  padding: 0.75rem;
}

.textarea-charcount-container {
  padding-bottom: 0.75rem;
}
</style>
